<template>
  <div class='modal-main' v-if="isShowModal" @click="moveModel">
    <div class='bg-black' @click="closeSouhuo" ></div>
    <div class='prod-popup' v-if="!(isNoProduct || isRemind)">
      <template v-if="isAuditing">
        <div class='close' @click="closeSouhuo"><i class="iconfont icon-close"></i></div>
        <div class='prod-popup-one flex'>
            <div class='pro-image'>
              <img :src='productInfo.WAPPicUrl'/>
            </div>
            <div class='pro-txt t_999'>
              <div class='flex test' v-if="isAuditingNext">京东价<div class="tianmao-price flex"><div class="yuan"> ￥</div>{{productInfo.ProductPrice | toFixed}}</div>
              </div>
              <div class='flex test' v-else>天猫价
                <div class="tianmao-price flex">
                  <div class="yuan"> ￥</div>{{productInfo.ProductPrice | toFixed}}
                </div>
                <div class='fanli'>
                    <div class='fanmoney'>返￥{{(productInfo.ProductPrice - productInfo.SaleDiscountPrice) | toFixed}}</div>
                </div>
              </div>
              <div class='flex'>到手价
                <div class='pro-price t_f23030 flex'>
                  <div class="yuan"> ￥</div>{{productInfo.SaleDiscountPrice | toFixed}}
                </div>
              </div>
              <div class="rest-price">剩余{{soHoInfo.RestCount}}件</div>
            </div>
        </div>
        <div class='item-describe' v-if="!isAuditing">
          <span class='iconfont icon-sanjiaoxing-copy'></span>
          <span class="fs-26">请前往淘宝APP搜索关键词，找到与上图完全一致的商品</span>
        </div>
        <div
          style="max-height: 498rpx;"
          v-if="soHoInfo.SortType !== 0 || soHoInfo.IsFreeShipping || soHoInfo.IsTmall || soHoInfo.IsGiveFI">
          <div class='prod-popup-two' v-if="!isAuditing">
            <div class='p-title'>搜索关键词</div>
            <div class='p-tab flex'><div>{{soHoInfo.SearchKey ? soHoInfo.SearchKey : '--'}}</div></div>
          </div>
          <div class='prod-popup-two' v-if="!isAuditing">
            <div class='p-title'>筛选条件</div>
            <div class='p-tab flex'>
              <div v-if="soHoInfo.SortType !== 0">按照{{soHoInfo.SortType | sortType}}排序</div>
              <div v-if="soHoInfo.IsFreeShipping">包邮</div>
              <div v-if="soHoInfo.IsTmall">天猫</div>
              <div v-if="soHoInfo.IsGiveFI">赠送运费险</div>
            </div>
          </div>
          <div class='prod-popup-two' v-if="isAuditingNext">
            <div class='p-title'>店铺名称</div>
            <div class='p-tab flex'><div>{{productInfo.ShopName}}</div></div>
          </div>
          <div class='prod-popup-two' v-else-if="isAuditing">
            <div class='p-title'>店铺名称</div>
            <div class='p-tab flex'><div>超级数码专营店</div></div>
          </div>
        </div>
        <div v-else>
          <div class='prod-popup-two' v-if="!isAuditing">
            <div class='p-title'>搜索关键词</div>
            <div class='p-tab flex'>
              <div>{{soHoInfo.SearchKey ? soHoInfo.SearchKey : '--'}}</div>
            </div>
          </div>
          <div class='prod-popup-two' v-if="isAuditingNext">
            <div class='p-title'>店铺名称</div>
            <div class='p-tab flex'><div>{{productInfo.ShopName}}</div></div>
          </div>
          <div class='prod-popup-two' v-else-if="isAuditing">
            <div class='p-title'>店铺名称</div>
            <div class='p-tab flex'><div>超级数码专营店</div></div>
          </div>
        </div>
        <div class='prod-btn' v-if="!isAuditing">
          <div>
            <div class='nav' @click="checkPasswordContent">验证商品链接</div>
          </div>
          <div class='t_right' @click="showCourse">如何验证？</div>
        </div>
        <div class='prod-btn' v-else>
          <div class='nav' @click="closeSouhuo">我知道了</div>
        </div>
      </template>
    </div>
    <div class='prod-popup min-h-850' v-if="isNoProduct">
      <div class='close' @click="closeSouhuo"><i class="iconfont icon-close"></i></div>
      <div class='pro-img'>
        <img :src="youpPath + soldoutGif"/>
      </div>
      <div class='soldout'>
        <div><span>opps~~</span></div>
        <span>商品被抢光了，下次早点来哟</span>
      </div>
      <div  class='soldout-btm flex space-between'>
        <div class='soldout-span flex'>
          <span>是否加入收藏夹？</span>
          <!-- <span class='question' @click="openRemindTip">?</span> -->
        </div>
        <form @click="addToRemindClip">
          <div :class="{'open-btn': true, 'disabled': isBuyRemind}">{{isBuyRemind ? '已加入' : '加入收藏夹'}}</div>
        </form>
      </div>
    </div>
    <div class='prod-popup min-h-850' v-if="isRemind">
      <div class='close' @click="closeSouhuo"><i class="iconfont icon-close"></i></div>
      <div class='pro-img'>
        <img :src='youpPath + actionGif' alt=""/>
      </div>
      <div class='soldout'>
        <span>已加入收藏夹，正在返回首页~</span>
      </div>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
export default {
  data () {
    return {
      shopName: '',
      wrongShopName: '',
      isPass: false,
      isRemind: false,
      isShopNameError: true,
      youpPath: IMG_BASE_URL,
      soldoutGif: '/upaiyun/Sys/20180508/5763870670533892643.gif',
      actionGif: '/upaiyun/Sys/20180508/4824525880709225818.gif',
      indexStep: 1,
      step2Img1: '/upaiyun/Sys/20180809/5382392882239969630.png',
      step2Img2: '/upaiyun/Sys/20180809/5764262134487007789.png',
      step3Img: '/upaiyun/Sys/20180809/5490644291185625751.png',
      readyTaskId: '',
      timaOut: null,
      // 淘宝口令
      taobaoPassword: ''
    }
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false
    },
    isBuyRemind: {
      type: Boolean,
      default: false
    },
    productInfo: {
      type: Object,
      default: () => ({})
    },
    soHoInfo: {
      type: Object,
      default: () => ({})
    },
    isNoProduct: {
      type: Boolean,
      default: false
    },
    isAuditing: {
      type: Boolean,
      default: true
    },
    isAuditingNext: {
      type: Boolean,
      default: false
    },
    propIndexStep: {
      type: Number,
      default: 1
    },
    // 以下-->倒计时相关props
    isShowCopy: {
      type: Boolean,
      default: false
    },
    isFeedback: {
      type: Boolean,
      default: false
    },
    isCounting: {
      type: Boolean,
      default: true
    },
    diffSeconds: {
      type: Number,
      default: 0
    }
  },
  updated () {
    if (!this.isShowModal || this.timaOut) {
      clearTimeout(this.timaOut)
    }
  },
  methods: {
    moveModel () {
      // 阻止Model向上冒泡
      return false
    },
    showCourse () {
      let isShowStepTwo = 0
      // 存在筛选条件
      if (this.soHoInfo.SortType !== 0 || this.soHoInfo.IsFreeShipping || this.soHoInfo.IsTmall || this.soHoInfo.IsGiveFI) {
        isShowStepTwo = 1
      }
      this.$router.push({
        name: 'courseStep',
        query: {
          isShowStepTwo: isShowStepTwo,
          indexStep: this.indexStep
        }
      })
    },
    closeSouhuo () {
      this.timaOut = setTimeout(() => {
        if (this.isNoProduct || this.isRemind) {
          this.$router.go(-1)
        } else {
          this.$emit('closeSouhuo')
        }
      }, 300)
    },
    openSouhuo () {
      this.isShopNameError = false
      this.shopName = ''
    },
    // 新 验证商品链接接口
    // checkPasswordContent () {
    //   Indicator.open({
    //     text: '加载中',
    //     spinnerType: 'triple-bounce'
    //   })
    // },
    // // 提示
    // openRemindTip () {
    //   MessageBox({
    //     title: '提示',
    //     message: '开启商品上架提醒，如该商品在7天内再次上架，平台将在第一时间为你推送微信消息，方便你迅速抢购到宝贝',
    //     showCancelButton: true,
    //     confirmButtonText: '我知道了'
    //   })
    // },
    // 加入提醒夹
    addToRemindClip () {
      if (this.isBuyRemind) return
      this.$emit('addToRemindClip')
    }
  },
  watch: {
    propIndexStep () {
      this.indexStep = this.propIndexStep
    }
  },
  filters: {
    toFixed (value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value).toFixed(2)
    },
    sortType (value) {
      var filterValue = '综合'
      if (value === 0) {
        filterValue = '综合'
      } else if (value === 1) {
        filterValue = '销量'
      } else if (value === 2) {
        filterValue = '价格低到高'
      } else if (value === 3) {
        filterValue = '价格高到低'
      } else {
        filterValue = '综合'
      }
      return filterValue
    }
  }
}
</script>

<style scoped>
  .modal-main {
    font-size: 13px;
  }
  .flex{
    display: flex;
  }
  .space-between{
    justify-content:space-between;
  }
  .bg-black{
    background: #000;
    opacity: 0.6;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 11;
    animation-fill-mode: backwards;
    animation: maskAnim .3s ease-in-out;
  }
  .b_fff{
    background: #fff;
  }
  .b_black{
    background: #2c2c2c;
    color: #fff;
  }
  .t_999{
    color: #999;
  }
  .t_f23030{
    font-size: 14px;
    color: #f23030;
  }
  .min-h-850{
    min-height: 32.5em;
  }
  .prod-popup{
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    z-index: 1000;
    background: #fff;
    border-top-left-radius:30px;
    border-top-right-radius: 30px;
    padding:4%;
    bottom: 0;
    max-height: 95%;
    overflow: scroll;
    animation-fill-mode: backwards;
    animation: pupopAnim .3s ease-in-out;
  }
  .prod-popup-one{
    align-items: flex-end;
    padding-bottom:4%;
    border-bottom: 1px solid #f2f2f2;
  }
  .pro-image{
    width: 9.5em;
    height: 9.5em;
    margin-right:3%;
  }
  .pro-image img{
    width:100%;
    height: 100%;
    border-radius:5px;
  }
  .pro-price span{
    margin-right: 2%;
    align-items: flex-end;
  }
  .pro-price span.t_999{
    text-decoration:line-through;
  }
  .pro-txt{
    font-size: 13px;
    vertical-align: text-bottom;
  }
  .pro-txt>div{
    margin-top:2%;
    line-height: 1.5em;
  }
  .test{
    display: flex;
    justify-content: flex-start;
    align-items: center
  }
  .pro-txt>div:nth-of-type(3) {
    margin-top:20rpx;
  }
  .close{
    position: absolute;
    top: 2%;
    right: 5%;
    width: 2em;
    height: 2em;
    text-align: center;
    line-height: 2em;
    border: 1px solid #999;
    border-radius: 50%;
    color: #999;
  }
  .prod-popup-two{
    border-bottom: 1px solid #f2f2f2;
    padding: 4% 0;
  }
  .p-title{
    line-height:1.1em;
  }
  .p-tab{
    flex-wrap: wrap;
  }
  .p-tab div{
    margin-top: 3%;
    padding:4px 3%;
    border-radius: 80px;
    background: #2c2c2c;
    color: #fff;
    margin-right: 2%;
    height: 2.1em;
    line-height: 2.1em;
    white-space:nowrap;
    font-size: 13px;
  }
  .prod-input{
    position: relative;
    align-items: center;
    padding: 4% 2;
    border-bottom: 1px solid #f2f2f2;
  }
  .prod-input div:nth-of-type(1){
    margin-right: 4.5%;
  }
  .prod-btn{
    margin-top:4.5%;
    margin-bottom:3%;
  }
  .prod-btn .nav{
    width: 10.7em;
    height: 3.4em;
    line-height: 3.4em;
    border-radius: 80px;
    display: block;
    background: #f23030;
    color: #fff;
    text-align: center;
    margin: 0 auto;
  }
  /*已抢光  */
  .pro-img{
    width: 11.5em;
    height: 11.5em;
    margin:3em auto 0;
  }
  .pro-img img{
    width: 100%;
    height: 100%;
  }
  .soldout{
    text-align: center;
    font-weight: bold;
    margin-top:3.8em;
    line-height:2.3em;
  }
  .soldout-btm{
    padding:4.5% 0;
    border-top: 1px solid #eee;
    position: absolute;
    width:calc(100% - 2.3em);
    bottom:0;
    align-items: center;
  }
  .soldout-btm form{
    display:block;
  }
  .open-btn{
    border-radius: 30px;
    display: block;
    overflow: inherit;
    background: #457EE8;
    color: #fff;
    padding: 5px 10px;
    cursor: pointer;
  }
  .open-btn.disabled{
    background: #999;
    pointer-events: none;
  }
  .soldout-text{
    align-items: center;
  }
  .question{
    margin-left:2%;
    background: #2c2c2c;
    color: #fff;
    width:1.1em;
    height: 1.1em;
    font-size: 13px !important;
    text-align: center;
    line-height: 1.1em;
    border-radius: 100%;
    display: block;
  }
  .weui-cell__ft{
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right: 0rpx;
  }
  .item-describe{
    position: relative;
    width: 100%;
    left: -1.15em;
    background: #f05c61;
    font-size: 13px;
    padding:3% 4%;
    color: #fff;
  }
  .icon-sanjiaoxing-copy{
    top: -2em;
    position:absolute;
    font-size:16px;
    left:2.3em;
    display: block;
    border-top:8px solid transparent;
    border-right:8px solid transparent;
    border-bottom:8px solid #f05c61;
    border-left:8px solid transparent;
  }
  .prod-popup-one{
    padding-bottom:4%;
  }
  .t_right{
    text-align: center;
    color: #409eff;
  }
  .prod-btn{
    display: flex;
    align-items: center;
  }
  .prod-btn>div{
    flex:1;
  }
  /* 返利 */
  .fanli{
    display: inline-block;
    position: relative;
  }
  .fanmoney{
    background: #ffe7bb;
    color: #ff6d2c;
    border:1px solid #ffd8bf;
    border-radius: 10px;
    font-size: 13px;
    padding: 4px 8px;
    margin-left: 12px;
  }
  .tianmao-price{
    color: #000;
    font-size: 15px;
  }
  .rest-price{
    background: #f1f1f1;
    display: inline-block;
    color:#000;
    padding: 2px 8px;
    border-radius: 5px;
  }
  .pro-txt .yuan {
    margin-right: 0;
  }
  /* 新版本 验证弹窗 */
  #shopKeyWords{
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
  }
  .b_f23030 {
    background: #EC0536;
  }
  .key_copy{
    font-size: 14px;
    text-align: right;
  }
  .no_find{
    background: #888;
    color:#fff;
  }
  .t_center{
    text-align: center;
  }
  .t_title{
    font-weight: bold;
    margin:3% 0;
    font-size: 15px;
  }
  .no-weight{
    font-weight: normal;
    display: inline;
  }
  .t_hlep{
    padding-bottom:4%;
    border-bottom:1px solid #eee;
  }
  .t_blue{
    color: #409EFf;
  }
  .mar_top_30{
    margin-top:2%;
    min-height: 17.5em;
  }
  .t_key{
    display: flex;
    align-items: center;
  }
  .key_tags{
    position: relative;
    background: #000;
    color: #fff;
    border-radius: 30px;
    padding: 0 1.1em;
    line-height: 1.7em;
    margin: 5px 10px 5px 0;
  }
  .tc_img{
    margin: 2% auto 0;
    width: 11.5em;
    min-height: 11.5em;
  }
  .tc_img img{
    width: 100%;
    height: 100%;
    margin:4% auto 0;
  }
  .mar_top_30>div:first-child{
    margin-bottom:2%;
  }
  .tc_img_itm{
    height: calc(17.5em - 2.5em);
    display: flex;
    align-items: center;
  }
  .tc_button{
    display: flex;
    justify-content: center;
    margin-top:3%;
  }
  .tc_btn{
    width:8.8em;
    height:3em;
    line-height: 3em;
    text-align: center;
    color: #fff;
    border-radius: 45px;
    margin: 0 3%;
    position: relative;
  }
  .tc_btn button{
    position: absolute;
    width: 100%;
  }
  .step_two{
    display: flex;
    justify-content:space-around;
    align-items: center;
    margin-top: 4%;
    padding: 0 4%;
    /* height: 17.5em; */
    overflow: hidden;
  }
  .step_two .iconfont{
    border:1px solid #ccc;
    color: #ccc;
    border-radius: 100%;
    font-size:14px;
    height:1.5em;
    text-align: center;
    width: 1.5em;
    line-height: 1.6em;
  }
  .step_img{
    /* height: 17.5em; */
    margin-top: 2%;
  }
  .step_img img{
    width:9.6em;
    height: 100%;
  }
  .shrink{
    flex-shrink:0;
  }
  .flex_wrap{
    flex-wrap: wrap;
  }
  @media screen and (max-height: 480px) {
    .tc_btn[data-v-2db8ea7a] {
      height: 2em;
      line-height: 2em;
    }
  }
  @keyframes maskAnim{
    0%{
      opacity: 0;
    }
    100%{
      opacity: 0.6;
    }
  }
  @keyframes pupopAnim{
    0%{
      bottom: -30em;
    }
    100%{
      bottom: 0;
    }
  }
  .taobaoPas{
    height: 40px;
    line-height: 40px;
    margin: 20px auto 0;
    padding: 0 20px;
  }
  .taobao_tit{
    width: 30%;
  }
  .taobao_input{
    width: 70%;
  }
  .taobao_input input{
    width: 100%;
    height: 40px;
    line-height: 40px;
  }
</style>
